const Joi = require('joi')
const fields = require('../fields')

const openSynthChipSchema = Joi.object({
    amount: fields.integerAboveZeroField.max(100).required(),
})

module.exports = openSynthChipSchema